export default {
  nav: {
    login: 'Iniciar Sesión',
  },
  hero: {
    badge: 'Servicio médico a domicilio en tu hotel',
    h1: 'Un médico profesional, directo a la puerta de tu habitación',
    sub: 'Atención {h} de forma rápida y segura. Sin filas, sin traslados — el cuidado que necesitas llega hasta ti.',
    cta_primary: 'Agenda tu cita',
    cta_secondary: 'Consultar mi expediente',
    pill1: 'Médicos certificados',
    pill2: 'Disponible 24/7',
    pill3: 'Expediente digital',
  },
"steps": {
  "tag": "¿Cómo funciona?",
  "h2": "Atención médica en cuatro pasos simples",
  "items": [
    {
      "title": "Solicita atención",
      "desc": "Informa al personal de recepción, concierge o a tu anfitrión que necesitas atención médica."
    },
    {
      "title": "Recibimos tu solicitud",
      "desc": "Nos encargamos de coordinar todo para brindarte la atención que necesitas."
    },
    {
      "title": "El médico acude a ti",
      "desc": "Asignamos al médico más cercano y acude directamente a la puerta de tu habitación."
    },
    {
      "title": "Consulta tu expediente",
      "desc": "Recibe la atención que necesitas y consulta tu expediente digital desde esta página."
    }
  ]
},
  search: {
    tag: 'Expediente digital',
    h2: 'Consulta y descarga tu expediente médico',
    sub: 'Ingresa tu folio o código para consultar y descargar tu expediente digital.',
    placeholder: 'Ej. DOM-2026-00184',
    btn: 'Buscar',
    searching: 'Buscando…',
  },
  faq: {
    tag: 'Preguntas frecuentes',
    h2: 'Resolvemos tus dudas',
    items: [
      {
        q: '¿Cuánto tiempo tarda en llegar el médico?',
        a: 'En zonas con cobertura, el médico llega a tu habitación en un promedio de 30 a 60 minutos después de confirmar tu cita. Te mantenemos informado del tiempo estimado en todo momento.',
      },
      {
        q: '¿Qué tipo de medicamentos pueden recetar?',
        a: 'Nuestros médicos certificados pueden emitir recetas para la mayoría de medicamentos de uso común. Los medicamentos controlados se manejan conforme a la regulación sanitaria vigente.',
      },
      {
        q: '¿Quién puede consultar mi expediente?',
        a: 'Únicamente la persona que cuente con el folio asignado durante la consulta puede acceder al expediente digital. Toda la información médica y personal se encuentra protegida conforme a la legislación mexicana en materia de protección de datos personales',
      },
    ],
  },
  footer: {
    tagline: 'Servicio médico a domicilio para huéspedes de hotel. Atención profesional, rápida y confiable, las 24 horas.',
    contact: 'Contacto',
    available: 'Atención 24/7',
    account: 'Cuenta',
    login: 'Iniciar Sesión',
    receipt: 'Consultar expediente',
    survey: 'Encuesta de satisfacción',
    rights: '© 2026 Domédica. Todos los derechos reservados.',
    privacy: 'Aviso de Privacidad',
    terms: 'Términos y Condiciones',
  },
  print: {
    title: 'CONSULTA MÉDICA',
    date: 'Fecha',
    folio: 'Folio',
    patient: 'DATOS DEL PACIENTE',
    full_name: 'Nombre completo',
    age: 'Edad',
    years: 'años',
    gender: 'Género',
    phone: 'Teléfono',
    country: 'País',
    language: 'Idioma',
    hotel: 'Hotel / Aliado',
    patient_type: 'Tipo de paciente',
    guest: 'Huésped',
    collaborator: 'Colaborador',
    vitals: 'SIGNOS VITALES',
    bp: 'Presión arterial',
    temp: 'Temperatura',
    hr: 'Frecuencia cardíaca',
    spo2: 'Saturación O₂',
    respiratory_rate: 'Frecuencia respiratoria',
    anthropometrics: 'DATOS ANTROPOMÉTRICOS',
    weight: 'Peso',
    height: 'Talla',
    bmi: 'IMC',
    nutrition_goal: 'Objetivo nutricional',
    additional_services: 'SERVICIOS ADICIONALES',
    psych_eval: 'EVALUACIÓN PSICOLÓGICA',
    consult_reason: 'Motivo de consulta',
    mood: 'Estado de ánimo',
    risk_level: 'Nivel de riesgo',
    history: 'ANTECEDENTES',
    diseases: 'Enfermedades previas',
    allergies: 'Alergias',
    medication: 'Medicación actual',
    diagnosis: 'DIAGNÓSTICO Y PLAN',
    symptoms: 'Síntomas',
    diagnosis_label: 'Diagnóstico',
    observations: 'OBSERVACIONES Y RECOMENDACIONES',
    not_registered: 'NO REGISTRADO',
    translating: 'Traduciendo…',
    download: 'Descargar PDF',
    send: 'Enviar Gmail',
    back: 'Volver al registro',
    doctor: 'Médico',
    license: 'Cédula profesional',
    signature: 'Firma',
  },
  survey: {
    title: 'Encuesta de satisfacción',
    subtitle: 'Tu opinión nos ayuda a mejorar nuestro servicio. Todas las preguntas marcadas con * son obligatorias.',
    hotel_label: '¿En qué hotel te hospedaste?',
    hotel_placeholder: 'Selecciona tu hotel',
    hotel_other: 'Otro',
    hotel_other_placeholder: 'Escribe el nombre del hotel',
    hint_poor_excellent: '1 = Deficiente, 5 = Excelente',
    hint_not_clear: '1 = Nada clara, 5 = Muy clara',
    hint_not_likely: '1 = Nada probable, 5 = Muy probable',
    q_tiempo_espera: '¿Cómo calificarías el tiempo de espera desde tu solicitud hasta la llegada del médico?',
    q_gafete: '¿El médico portó correctamente su gafete de identificación durante la visita?',
    q_presentacion: '¿Cómo calificarías la presentación e imagen profesional del médico (uniforme, higiene y aspecto general)?',
    q_atencion_medico: '¿Cómo calificarías la atención brindada por el médico?',
    q_claridad_explicacion: '¿Qué tan clara fue la explicación del médico sobre tu diagnóstico, tratamiento y seguimiento?',
    q_ingles: '¿Cómo calificarías el nivel de inglés del médico durante la consulta?',
    q_calidad_precio: '¿Cómo calificarías la relación calidad-precio del servicio médico recibido?',
    q_atencion_domedica: '¿Cómo calificarías el servicio general brindado por Domédica?',
    q_recomendacion: '¿Qué tan probable es que recomiendes Domédica a familiares o amigos que visiten Oaxaca?',
    comments_label: '¿Algún comentario adicional?',
    comments_placeholder: 'Cuéntanos más…',
    submit: 'Enviar encuesta',
    sending: 'Enviando…',
    incomplete_title: 'Formulario incompleto',
    incomplete_text: 'Por favor completa todas las preguntas obligatorias.',
    error_title: 'Error',
    error_default: 'No se pudo enviar la encuesta.',
    thanks_title: '¡Gracias por tu respuesta!',
    thanks_text: 'Tu opinión fue registrada exitosamente.',
    back: 'Volver al inicio',
    scan_qr: 'Escanea para responder la encuesta',
  },
  services: {
    tag: 'Servicios adicionales',
    h2: 'Costos de servicios adicionales',
    sub: 'Estos conceptos pueden aplicar de forma adicional al costo de la consulta, según lo requiera tu atención médica.',
    concept: 'Concepto',
    base_price: 'Precio base',
    items: [
      { concept: 'Atención a un segundo paciente no agendado', price: '75% del costo de la primera consulta' },
      { concept: 'Emisión de recetas adicionales o con características especiales', price: '$100.00' },
      { concept: 'Curación simple', price: '$250.00' },
      { concept: 'Retiro de puntos', price: '$250.00' },
      { concept: 'Aplicación de medicamento inyectable (sin medicamento)', price: '$120.00' },
      { concept: 'Sutura simple (hasta 3 cm)', price: '$600.00' },
      { concept: 'Sutura intermedia (3-5 cm)', price: '$800.00' },
      { concept: 'Sutura mayor (más de 5 cm)', price: '$1,000.00' },
    ],
  },
};
